import React, { useId } from 'react';

export type PointItemCategoryTabMode = 'points' | 'coins' | 'items' | 'notes';

const POINT_HEX_PATH =
  'M0 7.2168C0 6.04925 0.634272 4.97888 1.65039 4.4082L8.40039 0.427735L8.4248 0.414063C8.91721 0.14257 9.47091 0 10.0332 0C10.5954 3.4286e-05 11.1483 0.142632 11.6406 0.414063C11.649 0.418688 11.6578 0.422871 11.666 0.427735L18.416 4.4082C18.476 4.44358 18.5291 4.48675 18.5791 4.53222C18.9836 4.80535 19.3222 5.16635 19.5674 5.59082C19.853 6.08533 20.0025 6.6468 20 7.21777V14.5019C19.9999 15.6584 19.3765 16.7193 18.376 17.2939L11.627 21.5644C11.6096 21.5754 11.5913 21.5858 11.5732 21.5957C11.1515 21.8273 10.6846 21.9629 10.2061 21.9932L10 22C9.44998 22 8.90888 21.8604 8.42676 21.5957C8.40872 21.5858 8.39044 21.5754 8.37305 21.5644L1.62305 17.2949C1.14111 17.0189 0.737374 16.6235 0.453125 16.1455C0.157909 15.6489 0.00121619 15.0816 0 14.5039V7.2168ZM2 14.5L2.01172 14.6631C2.03387 14.825 2.0878 14.9816 2.17188 15.123C2.25598 15.2645 2.36731 15.3875 2.49902 15.4844L2.6377 15.5723L2.69238 15.6045L9.40234 19.8486C9.58634 19.947 9.79122 20 10 20L10.1592 19.9892C10.3121 19.9699 10.4599 19.9216 10.5967 19.8486L17.3076 15.6045L17.3604 15.5732C17.7584 15.3544 17.9999 14.9428 18 14.5019V7.21094C18.0013 6.9934 17.9447 6.7792 17.8359 6.59082C17.7271 6.40241 17.57 6.24626 17.3809 6.13867C17.3243 6.1065 17.2726 6.06851 17.2246 6.02734L10.668 2.16211C10.4731 2.05616 10.2551 2.00003 10.0332 2C9.8124 2 9.59455 2.05427 9.40039 2.15918L2.66602 6.13086C2.6574 6.13594 2.64841 6.14069 2.63965 6.14551C2.24103 6.3646 2 6.77633 2 7.2168V14.5Z';

const POINT_P_PATH =
  'M10.6364 6.02734H7.99174C7.72871 6.02734 7.47646 6.1327 7.29047 6.32024C7.10449 6.50777 7 6.76213 7 7.02734V15.0273C7 15.2925 7.10449 15.5469 7.29047 15.7344C7.47646 15.922 7.72871 16.0273 7.99174 16.0273C8.25476 16.0273 8.50701 15.922 8.693 15.7344C8.87898 15.5469 8.98347 15.2925 8.98347 15.0273V13.3607H10.6364C11.6008 13.3607 12.5257 12.9744 13.2077 12.2867C13.8896 11.5991 14.2727 10.6665 14.2727 9.69401C14.2727 8.72155 13.8896 7.78892 13.2077 7.10128C12.5257 6.41365 11.6008 6.02734 10.6364 6.02734ZM8.98347 11.3607H10.6364C11.0747 11.3607 11.4952 11.1851 11.8051 10.8725C12.1151 10.5599 12.2893 10.136 12.2893 9.69401C12.2893 9.25198 12.1151 8.82806 11.8051 8.5155C11.4952 8.20294 11.0747 8.02734 10.6364 8.02734H8.98347V11.3607Z';

const NOTEPAD_PATH =
  'M15.75 12C15.75 12.1989 15.671 12.3897 15.5303 12.5303C15.3897 12.671 15.1989 12.75 15 12.75H9C8.80109 12.75 8.61032 12.671 8.46967 12.5303C8.32902 12.3897 8.25 12.1989 8.25 12C8.25 11.8011 8.32902 11.6103 8.46967 11.4697C8.61032 11.329 8.80109 11.25 9 11.25H15C15.1989 11.25 15.3897 11.329 15.5303 11.4697C15.671 11.6103 15.75 11.8011 15.75 12ZM15 14.25H9C8.80109 14.25 8.61032 14.329 8.46967 14.4697C8.32902 14.6103 8.25 14.8011 8.25 15C8.25 15.1989 8.32902 15.3897 8.46967 15.5303C8.61032 15.671 8.80109 15.75 9 15.75H15C15.1989 15.75 15.3897 15.671 15.5303 15.5303C15.671 15.3897 15.75 15.1989 15.75 15C15.75 14.8011 15.671 14.6103 15.5303 14.4697C15.3897 14.329 15.1989 14.25 15 14.25ZM20.25 3.75V18.75C20.25 19.5456 19.9339 20.3087 19.3713 20.8713C18.8087 21.4339 18.0456 21.75 17.25 21.75H6.75C5.95435 21.75 5.19129 21.4339 4.62868 20.8713C4.06607 20.3087 3.75 19.5456 3.75 18.75V3.75C3.75 3.55109 3.82902 3.36032 3.96967 3.21967C4.11032 3.07902 4.30109 3 4.5 3H6.75V2.25C6.75 2.05109 6.82902 1.86032 6.96967 1.71967C7.11032 1.57902 7.30109 1.5 7.5 1.5C7.69891 1.5 7.88968 1.57902 8.03033 1.71967C8.17098 1.86032 8.25 2.05109 8.25 2.25V3H11.25V2.25C11.25 2.05109 11.329 1.86032 11.4697 1.71967C11.6103 1.57902 11.8011 1.5 12 1.5C12.1989 1.5 12.3897 1.57902 12.5303 1.71967C12.671 1.86032 12.75 2.05109 12.75 2.25V3H15.75V2.25C15.75 2.05109 15.829 1.86032 15.9697 1.71967C16.1103 1.57902 16.3011 1.5 16.5 1.5C16.6989 1.5 16.8897 1.57902 17.0303 1.71967C17.171 1.86032 17.25 2.05109 17.25 2.25V3H19.5C19.6989 3 19.8897 3.07902 20.0303 3.21967C20.171 3.36032 20.25 3.55109 20.25 3.75ZM18.75 4.5H17.25V5.25C17.25 5.44891 17.171 5.63968 17.0303 5.78033C16.8897 5.92098 16.6989 6 16.5 6C16.3011 6 16.1103 5.92098 15.9697 5.78033C15.829 5.63968 15.75 5.44891 15.75 5.25V4.5H12.75V5.25C12.75 5.44891 12.671 5.63968 12.5303 5.78033C12.3897 5.92098 12.1989 6 12 6C11.8011 6 11.6103 5.92098 11.4697 5.78033C11.329 5.63968 11.25 5.44891 11.25 5.25V4.5H8.25V5.25C8.25 5.44891 8.17098 5.63968 8.03033 5.78033C7.88968 5.92098 7.69891 6 7.5 6C7.30109 6 7.11032 5.92098 6.96967 5.78033C6.82902 5.63968 6.75 5.44891 6.75 5.25V4.5H5.25V18.75C5.25 19.1478 5.40804 19.5294 5.68934 19.8107C5.97064 20.092 6.35218 20.25 6.75 20.25H17.25C17.6478 20.25 18.0294 20.092 18.3107 19.8107C18.592 19.5294 18.75 19.1478 18.75 18.75V4.5Z';

const PointRainbowIcon: React.FC<{ size?: number }> = ({ size = 18 }) => {
  const gradId = useId().replace(/:/g, '');
  const height = Math.round(size * 1.1);
  const gradient = `url(#${gradId})`;
  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 20 22"
      fill="none"
      aria-hidden
    >
      <defs>
        <linearGradient id={gradId} x1="0" y1="0" x2="20" y2="22" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#ff5f6d" />
          <stop offset="22%" stopColor="#ffc371" />
          <stop offset="45%" stopColor="#47cf73" />
          <stop offset="68%" stopColor="#24c6dc" />
          <stop offset="100%" stopColor="#a166ff" />
        </linearGradient>
      </defs>
      <path d={POINT_HEX_PATH} fill={gradient} />
      <path fillRule="evenodd" clipRule="evenodd" d={POINT_P_PATH} fill={gradient} />
    </svg>
  );
};

const CoinCategoryIcon: React.FC<{ size?: number }> = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden>
    <circle cx="12" cy="12" r="10" fill="#f39c12" />
    <circle cx="12" cy="12" r="8" fill="#f1c40f" />
    <text x="12" y="16" fontSize="12" fontWeight="bold" fill="#f39c12" textAnchor="middle">
      C
    </text>
  </svg>
);

/** 탭용 카드 스택 — 내부 불투명 채움 */
const ItemCategoryTabIcon: React.FC<{ size?: number }> = ({ size = 18 }) => (
  <svg
    className="cp-pin-tab-item-stack"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
  >
    <rect
      x="2"
      y="6"
      width="12"
      height="16"
      rx="2"
      fill="#ececec"
      stroke="#555"
      strokeWidth="1.5"
      transform="rotate(-10 8 14)"
    />
    <rect
      x="6"
      y="4"
      width="12"
      height="16"
      rx="2"
      fill="#f5f5f5"
      stroke="#555"
      strokeWidth="1.5"
    />
    <rect
      x="10"
      y="6"
      width="12"
      height="16"
      rx="2"
      fill="#ffffff"
      stroke="#555"
      strokeWidth="1.5"
      transform="rotate(10 16 14)"
    />
  </svg>
);

const NotepadCategoryIcon: React.FC<{ size?: number }> = ({ size = 18 }) => (
  <svg
    className="cp-pin-tab-notepad"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden
  >
    <rect
      className="cp-pin-tab-notepad-body"
      x="4.5"
      y="2.5"
      width="15"
      height="19"
      rx="2.2"
      fill="#fff3a3"
    />
    <path className="cp-pin-tab-notepad-detail" d={NOTEPAD_PATH} fill="#333333" />
  </svg>
);

const PointItemCategoryTabIcon: React.FC<{ mode: PointItemCategoryTabMode; size?: number }> = ({
  mode,
  size = 18,
}) => {
  if (mode === 'points') {
    return <PointRainbowIcon size={size} />;
  }
  if (mode === 'coins') {
    return <CoinCategoryIcon size={size} />;
  }
  if (mode === 'items') {
    return <ItemCategoryTabIcon size={size} />;
  }
  return <NotepadCategoryIcon size={size} />;
};

export default PointItemCategoryTabIcon;
